<template>
    <div id="stadiafr-jeux-login">
        <div>
            <div class="logo"></div>
            <div class="wordings">
                Déconnexion en cours...
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Logout",
    components: {

    },
    data: () => ({
        
    }),
    methods: {

    }
}
</script>